export default __webpack_public_path__ + "static/media/RiceFields.475a04bc.jpg";